<template>
    <div class="select_multiple">
    <p v-if="showDashesPrompt"><em>You'll have a chance to edit these or fill in the blanks later.</em></p>
        <div v-for="(item,index) in message.options.values" :key="index">
            <input type="checkbox" :id="'select_' + index" :value="item" v-model="selectedItems">
            <label :for="'select_' + index" v-html="item" />
        </div>

        <button class="save" @click="save">Save</button>
    </div>
</template>

<style scoped>
    @keyframes fromleft {
        0%   {left:-200px; top:0px;}
        75%  {left:40px; top:0px;}
        100% {left:0px; top:0px;}
    }

    .select_multiple {
        animation-name: fromleft;
        animation-duration: 1s;
        animation-timing-function: ease-in-out;
        position: relative;
    }

</style>

<script>
import { Message } from '@/bot-engine.es5.js';

export default {
    name: 'SelectMultiple',
    props: {
        message: {
            type: Message
        }
    },
    data() {
        return {
          selectedItems: []
        }
    },
    computed: {
        showDashesPrompt() {
            for (let index in this.message.options.values) {
                if (this.message.options.values[index].includes("_")) {
                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        save() {
            let key = this.message.options.varName;
            
            this.$emit('input', {key: key, value: this.selectedItems});
        },
        cancel() {
            let key = this.message.options.varName;
            
            this.$emit('input', {key: key, value: []});
        }
    }
}
</script>
